<template>
  <div class="placement-tests">
    <van-tabs v-model="active" v-if="!startTest">
      <van-tab
        v-for="({ title, components }, index) in tabs"
        :title="$t(title)"
        :key="`${index}-${title}`"
      >
        <component
          v-for="component in components"
          :key="component"
          :is="component"
          @handleStartTest="handleStartTest"
        />
      </van-tab>
    </van-tabs>
    <PlacementTest
      v-if="startTest"
      :id="testId"
      @handleDoneTest="handleDoneTest"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import accountMixin from "@/mixins/accountMixin";
import InvitePlacementTest from "@/views/InvitePlacementTest";
import MyPlacementTestResults from "@/components/MyPlacementTestResults";
import PlacementTestResults from "@/components/PlacementTestResults";
import PlacementTestListing from "@/components/PlacementTestListing";
import PlacementTest from "@/components/PlacementTest";
export default {
  name: "PlacementTests",
  components: {
    PlacementTest,
    InvitePlacementTest,
    MyPlacementTestResults,
    PlacementTestResults,
    PlacementTestListing
  },
  mixins: [accountMixin],
  data() {
    return {
      startTest: false,
      testId: null,
      active: 0,
      teacherTabs: [
        {
          title: "Student Tests",
          components: ["PlacementTestResults"]
        },
        {
          title: "Invites",
          components: ["InvitePlacementTest"]
        }
      ],
      studentTabs: [
        {
          title: "Tests",
          components: ["PlacementTestListing", "MyPlacementTestResults"]
        }
      ]
    };
  },
  computed: {
    ...mapState("placementTest", ["myPlacementTests"]),
    tabs() {
      return this.isTeacher
        ? this.teacherTabs.concat(this.studentTabs)
        : this.studentTabs;
    }
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("placementTest", ["getMyPlacementTests"]),
    handleDoneTest() {
      this.testId = null;
      this.startTest = false;
    },
    handleStartTest(id) {
      const test = this.myPlacementTests.data.results.find(t => t.id === id);
      let title = test?.name;
      let timeSec = test?.time ? test?.time : 1800;
      let message = this.$t("Are u ready to take the test now[no time limit]");
      if (timeSec > 0) {
        const min = Math.round((timeSec / 60) * 100) / 100;
        message = this.$t("Are u ready to take the test now", { min });
      }
      this.$dialog
        .confirm({ title, message })
        .then(() => {
          this.testId = id;
          this.startTest = true;
        })
        .catch(() => {
          // maybe popup some message?
        });
    }
  },
  created() {
    this.SET_PAGE_TITLE("My Placement Tests");
    this.getMyPlacementTests();
  }
};
</script>

<style lang="scss">
.placement-tests {
  .placementTestRow {
    &:first-child {
      border-top: 1px solid #e3e3e3;
    }

    padding: 20px;
    border-bottom: 1px solid #e3e3e3;
    .question,
    .answer {
      padding: 10px;
    }
    .question {
      display: flex;
      .questionNumber {
        width: 30px;
        font-weight: bold;
      }
      .questionBody {
        .sentence {
          padding-bottom: 10px;
          display: flex;
          align-items: center;
        }
      }
    }
    .answer {
      padding-left: 40px;
      .checkbox {
        padding-left: 10px;
        padding-right: 10px;
      }
      display: flex;

      .answerOption {
        &.correct {
          border-bottom: 3px solid red;
        }
      }
    }
  }
  // .stats-box-area {
  //   position: absolute;
  //   bottom: 50px;
  //   background: rgba(255, 255, 255, 0.8);
  //   padding: 30px;
  // }
}
</style>
